import { FASSMOSS_DOMAIN, YOO_FINDS_CDN, YOO_FINDS_DOMAIN } from "@/common";
import { RouteStack } from "@/shared/constants/base";
import { TElevatorInfo } from "@/typings";

export const BANNER_BG_LA_2025 = `${YOO_FINDS_CDN}/pc/la-2025/banner/banner-bg-v10.webp`;

export const FASSMOSS_LOGO_LA_2025 = `${YOO_FINDS_CDN}/pc/la-2025/header/fassmoss-logo.webp`;

export const SCHEDULE_OBJECTS = `${YOO_FINDS_CDN}/pc/la-2025/schedule/objects.webp`;

export const SCHEDULE_FLOWER = `${YOO_FINDS_CDN}/pc/la-2025/schedule/flower.webp`;

export const SCHEDULE_SAWTOOTH_LA_2025 = `${YOO_FINDS_CDN}/pc/la-2025/schedule/sawtooth.webp`;

export const LA_SIGN_UP_BANNER = `${YOO_FINDS_CDN}/pc/la-2025/tickets-page/tickets-banner.webp`;

export const LA_2025_ABOUT_US_list = [
  `${YOO_FINDS_CDN}/pc/la-2025/about-us/about-us-1.webp`,
  `${YOO_FINDS_CDN}/pc/la-2025/about-us/about-us-2-v2.png`,
  `${YOO_FINDS_CDN}/pc/la-2025/about-us/about-us-3.webp`,
];

export const LA_2025_HIGHLIGHTS_STAR = `${YOO_FINDS_CDN}/pc/la-2025/highlights/star-2.png`;

export const LA_2025_EVENT_GUESTS_LIST = [
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-1.webp`,
    name: "Alex Lomov",
    brand_name: "Snap Supplements",
    job_title: "Co-founder",
    description:
      "Alex Lomov, Co-Founder of Snap Supplements®. Together with my colleagues and friends, we are building the best supplement brand in the world.",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-2.webp`,
    name: "Megan Reep",
    brand_name: "Mawwicks",
    job_title: "Founder",
    description:
      "Megan is not only a skilled candle maker, but also a devoted mental health advocate and full - time mom—pouring love, intention, and creativity into every candle she makes.",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-3.webp`,
    name: "Michael Reep",
    brand_name: "Mavwicks",
    job_title: "Co-founder",
    description:
      "Meet Megan and Michael, founder and co-founder of Mavwicks Candle Co. Megan is a candle maker, mental health advocate, and full-time mom ",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-4.webp`,
    name: "Shaina Rainford",
    brand_name: "Bask and Lather Co",
    job_title: "Founder & CEO",
    description: "Chief Executive Officer of Bask and Lather Co",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-5.webp`,
    name: "Gia Fey",
    brand_name: "Creator",
    job_title: "@giafey",
    description:
      "Top women’s fashion & beauty category with average monthly GMV 700k on 2 accounts (1 in English & 1 in Spanish), grossing 1 million in commission since starting Feb 2024.",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-6.webp`,
    name: "Victoria Prince",
    brand_name: "Creator",
    job_title: "@vprincemusic",
    description:
      "Hawaii-born, LA-based fashion and beauty creator, founder of Kawela Skin, TikTok partner, and honored as an Iconic Influencer by TikTok, with $6.33M GMV and 508.7K followers.",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-7-v3.png`,
    name: "Liz The Clearance Queen",
    brand_name: "Creator",
    job_title: "@liz_the_clearancequeen",
    description: "Top 10 creator with $4M+ GMV",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-8-v3.png`,
    name: "Angie Roman",
    brand_name: "Creator",
    job_title: "@angiexroman",
    description:
      "Top women’s category creator with $4M+ GMV, avg. $200-250K GMV",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-9-v3.png`,
    name: "Carlos Antonio",
    brand_name: "Creator",
    job_title: "@carlosantoniocerv",
    description:
      "Latino creator with over 1.5M followers and significant influence in the beauty industry",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/event-guests/guest-10-v2.png`,
    name: "janey💘",
    brand_name: "Creator",
    job_title: "@janeybonbon",
    description:
      "“Over $3 million in TikTok Shop GMV, more than 200 million total video views, and over 10 million views on a single video.”",
  },
];

export const LA_HIGHLIGHTS_REVIEW_LIST = [
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/highlights-review/highlights-review-1.webp`,
    city: "📍 LA",
    date: "📅 October 22, 2024",
    influencerCount: "200",
    influencerCountSuffix: "+",
    brandCount: "50",
    brandCountSuffix: "+",
    expertCount: "15",
    expertCountSuffix: "+",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/highlights-review/highlights-review-2.png`,
    city: "📍 NY",
    date: "📅 March 28, 2025",
    influencerCount: "250",
    influencerCountSuffix: "+",
    brandCount: "50",
    brandCountSuffix: "+",
    expertCount: "15",
    expertCountSuffix: "+",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/highlights-review/highlights-review-3-v2.webp`,
    city: "📍 Dallas",
    date: "📅 April 30, 2025",
    influencerCount: "300",
    influencerCountSuffix: "+",
    brandCount: "30",
    brandCountSuffix: "+",
    expertCount: "10",
    expertCountSuffix: "+",
  },
];

export const MERCHANT_ICON_LIST = [
  `${YOO_FINDS_CDN}/pc/la-2025/merchant/merchant-icon-1.png`,
  `${YOO_FINDS_CDN}/pc/la-2025/merchant/merchant-icon-2.png`,
  `${YOO_FINDS_CDN}/pc/la-2025/merchant/merchant-icon-3.png`,
  `${YOO_FINDS_CDN}/pc/la-2025/merchant/merchant-icon-4.png`,
  `${YOO_FINDS_CDN}/pc/la-2025/merchant/merchant-icon-5.png`,
  `${YOO_FINDS_CDN}/pc/la-2025/merchant/merchant-icon-6.png`,
  `${YOO_FINDS_CDN}/pc/la-2025/merchant/merchant-icon-7.png`,
  `${YOO_FINDS_CDN}/pc/la-2025/merchant/merchant-icon-8.png`,
];

export const ELEVATOR_LIST: TElevatorInfo[] = [
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/elevator/register-now.png`,
    href: `${FASSMOSS_DOMAIN}creator-picks-la/registration`,
    type: "signUp",
  },
  {
    src: `${YOO_FINDS_CDN}/pc/la-2025/elevator/become-a-sponsor.png`,
    href: `${YOO_FINDS_DOMAIN}${RouteStack.La2025.becomeSponsor}`,
    type: "sponsor",
  },
];

export const CHECK_TICKET_QRCODE = `${YOO_FINDS_CDN}/pc/personal-center/tickets/check-qrcode.webp`;
